import React from "react";
import { AgreementPage } from "@/components";
import agreementsData from "@/assets/agreements/agreements.json";

/**
 * Crisis page component that displays crisis resources and the SerenitAI
 * safety protocol. Published at app.serenit.ai/crisis to satisfy SB 243
 * §22602(b) and reachable from the drawer, ToS, Privacy Policy, and the
 * landing footer.
 */
export default function CrisisScreen() {
  return (
    <AgreementPage title="Crisis Resources" content={agreementsData.crisis} />
  );
}
